import { UserLocationModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";
export class UserLocationRepo extends BaseDataRepository<UserLocationModel> {
  protected baseUrl = 'userlocation';

  async getByUserIdAsync(id: number) : Promise<UserLocationModel[]>{
    const response = await this.client.get(`${this.baseUrl}/user/${id}`)
    return this.handleResponse<UserLocationModel[]>(response)!
  }
  async getUsersByLocationAsync(locationId: number | string) : Promise<UserLocationModel[]>{
    const response = await this.client.get(`${this.baseUrl}/getusersbylocation?locationIds=${locationId}`)
    return this.handleResponse<UserLocationModel[]>(response)!
  }

}

export default UserLocationRepo;
